module.exports = __webpack_public_path__ + "static/img/mapa_esp.4b7dbdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/mapa_esp.png
// module id = n4eH
// module chunks = 0